export default __webpack_public_path__ + "static/media/phone.063578d5.jpg";